import { SubscriptionPeriod } from '../common/interfaces';

export abstract class SubscriptionService {
  preselectedPeriod?: SubscriptionPeriod;
  abstract manageSubscription(): Promise<void>;
  abstract handleUpgrade(): Promise<void>;
  abstract upgradeToPro(period: SubscriptionPeriod, promoCode: string | undefined, redirect?: boolean): Promise<void>;
}
